import { createContext } from 'react'

interface PaywallProviderContext {
  open: (operationInfo?: {
    isAllowed: boolean
    requestedLimit: number
    availableLimit: number
    isReadOnly?: boolean
  }) => void
  close: () => void
}

export const PaywallContext = createContext<PaywallProviderContext>({
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  close: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  open: () => {},
})
